

const useFields = () => {

    const fields = [
        {
            name: "email",
            component: "input",
            placeholder: "מייל",
            autocomplete:"email",
        }
    ]

    return fields
}


export default useFields